import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import PageWrapper from 'ui/PageWrapper';
import { useHelpSections } from 'ui/help/hooks';
import HelpTableOfContents from 'ui/help/HelpTableOfContents';
import HelpSection from 'ui/help/HelpSection';
import ScrollToAnchor from 'ui/ScrollToAnchor';
import { DomId } from 'constants/DomId';

import messages from './messages';

const PageHelp = () => {
  const { sections } = useHelpSections();
  return (
    <PageWrapper>
      <ScrollToAnchor />
      <Container maxWidth='lg'>
        <Typography
          sx={{ textAlign: 'center', margin: '25px 0px' }}
          variant='h3'
          id={DomId.HelpTop}
        >
          <FormattedMessage {...messages.description} />
        </Typography>
        <HelpTableOfContents sections={sections} />
        <Box>
          {sections.map((section) => (
            <HelpSection key={section.hash} section={section} />
          ))}
        </Box>
      </Container>
    </PageWrapper>
  );
};

export default PageHelp;
